import { Product } from "../data/products";
import { CartItem } from "./cartTypes";

export function formatPrice(value: number) {
  return `${value.toLocaleString("fr-FR")} FCFA`;
}

export function getCartTotal(items: CartItem[], products: Product[]) {
  return items.reduce((total, item) => {
    const product = products.find((p) => p.id === item.productId);
    if (!product) return total;
    return total + product.priceValue * item.quantity;
  }, 0);
}

export function getCartQuantity(items: CartItem[]) {
  return items.reduce((total, item) => total + item.quantity, 0);
}
